import { faKey, faSave, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import axios from "axios";
import SrvButton from "../../../components/global/SrvButton";
import ErrorAdd from "../../../util/ErrorAdd";


function ModalPasswordChange(props) {
    const { show, onHide, id_type } = props;

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    const [password, setPassword] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(null);

    //ОТКРЫТИЕ/ЗАКРЫТИЕ МОДАЛЬНОЕ ОКНО
    useEffect(() => {
        //открытие
        if (show === true) {
            setLog(null);
            setLoading(false)
        }
    }, [show]);


    function changeHandler() {

        setLoading(true);
        setLog(null);

        if (password === null || password === '' || password === undefined) {
            setLog('Введите пароль');
            setLoading(false);
        }
        else if (confirmPassword === null || confirmPassword === '' || confirmPassword === undefined) {
            setLog('Введите пароль еще раз');
            setLoading(false);
        }
        else if (confirmPassword !== password) {
            setLog('Пароли не совпадают');
            setLoading(false);
        }
        else if (password.length < 8) {
            setLog('Пароль должен быть минимум 8 символов');
            setLoading(false);
        }
        else {
            axios.post('/api_main/user/passwordUpdate', { Password: password, Password_Confirm: confirmPassword })
                .then((res) => {
                    if (res.data.Status !== 1) {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                    else {
                        //onHide();
                        return window.location.replace(process.env.REACT_APP_DOMAIN_SERVICE);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Изменение пароля</div>

                    <div className="text-center"><b>Внимание!</b><br></br> После изменения пароля необходимо будет войти заново на всех устройствах.</div>
                    <div className="mb-3">
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Пароль</Form.Label>
                            <Form.Control type="password" defaultValue={password} onChange={(e) => setPassword(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="mb-3">
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Пароль еще раз</Form.Label>
                            <Form.Control type="password" defaultValue={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                        </Form.Group>
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-25 mb-10">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="save" loading={loading} size={'lg'} onClick={() => changeHandler()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ModalPasswordChange;
